import { HEADING_LEVELS, normaliseHeadingLevel } from "@/utils/headingSize";

/**
 * Shared dropdown for picking a semantic heading level (H1-H6). Every
 * font-size control in the CMS uses this so admins always think in
 * heading levels rather than pixels.
 *
 * Props:
 *  - value:   current level (e.g. "h3"); legacy/blank values are coerced to H3
 *  - onChange: (newLevel) => void
 *  - testId:  optional data-testid forwarded to the <select>
 *  - className: optional Tailwind className overrides
 */
export default function HeadingLevelSelect({
  value,
  onChange,
  testId,
  className = "",
}) {
  const normalised = normaliseHeadingLevel(value);
  return (
    <select
      value={normalised}
      onChange={(e) => onChange && onChange(e.target.value)}
      className={`w-full h-9 rounded-md border border-input bg-background px-3 text-sm ${className}`}
      data-testid={testId}
    >
      {HEADING_LEVELS.map((lvl) => (
        <option key={lvl.value} value={lvl.value}>
          {lvl.label}
        </option>
      ))}
    </select>
  );
}
